module.exports = __webpack_public_path__ + "static/media/bed.570057f9.png";